// extracted by mini-css-extract-plugin
export default {"paginator":"Paginator_paginator__Vwitv"};